export default {

  popup (name, url, redirectUri, options) {
    let width = 452
    let height = 633

    if (name === 'facebook') {
      width = 580
      height = 400
    }

    const left = (window.screen.width / 2) - ((width / 2) + 10)
    const top = (window.screen.height / 2) - ((height / 2) + 50)

    const popup = window.open(url, name,
      'directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0' +
      'left=' + left + ',top=' + top + ',screenX=' + left + ',screenY=' + top + ', width=' + width + ', height=' + height)
    if (popup && popup.focus) {
      popup.focus()
    }

    return this._pooling(redirectUri, popup)
  },

  _pooling (redirectUri, popup) {
    return new Promise((resolve, reject) => {
      const redirectUriParser = document.createElement('a')
      redirectUriParser.href = redirectUri
      const redirectUriPath = this._getFullUrlPath(redirectUriParser)

      let poolingInterval = setInterval(() => {
        if (!popup || popup.closed || popup.closed === undefined) {
          clearInterval(poolingInterval)
          poolingInterval = null
          reject(new Error('Auth popup window closed'))
        }

        try {
          const popupWindowPath = this._getFullUrlPath(popup.location)

          if (popupWindowPath === redirectUriPath) {
            console.log(popup.location)
            const query = this._parseQueryString(popup.location.search.substring(1).replace(/\/$/, ''))
            console.log(query)
            resolve(query)
            clearInterval(poolingInterval)
            poolingInterval = null
            popup.close()
          }
        } catch (e) {
          // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
        }
      }, 250)
    })
  },
  _getFullUrlPath (location) {
    const isHttps = location.protocol === 'https:'
    return location.protocol + '//' + location.hostname +
      ':' + (location.port || (isHttps ? '443' : '80')) +
      (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname)
  },
  _parseQueryString (str) {
    let obj = {}
    let key
    let value;
    (str || '').split('&').forEach((keyValue) => {
      if (keyValue) {
        value = keyValue.split('=')
        key = decodeURIComponent(value[0])
        obj[key] = (value[1]) ? decodeURIComponent(value[1]) : true
      }
    })
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/utils/popup.js